export default __webpack_public_path__ + "static/media/guru.5b9bdef6.svg";